export const Form = (() => {
	'use strict';

	let title, shortcode;
	
	function init() {
		title = $('.form--title');
		shortcode = $('.form--shortcode');
		
		form();
	}

	function form() {
		title.first().addClass('active');
		shortcode.first().addClass('active');
		
		title.click(function(){
			var id = $(this).attr('id');
			$(this).addClass('active').siblings().removeClass('active');
			
			if ( $( ".form--shortcode" ).hasClass( id ) ) {
				$('.form--shortcode.' + id).addClass('active').siblings().removeClass('active');
			}
		});
	}
	return {
		init: init,
		name: 'form'
	};
})();
